<template>
    <div id="wellcome">
        <div v-if="modelShow">
      <pay :dialogShow="modelShow" ref="userModel" @pushdata="getSys"  @modelChange="modelShowChange" />
    </div>
        <div>
            <div v-for="item in list" :key="item.title" class="content">
                <div class="item">
                    <div>
                        <div style="display: flex;margin: 10px;justify-content: space-between;">
                            <div style="display: flex;">
                                <img :src="item.icon" alt="" class="icon">
                                <div>{{ item.title }}</div>
                            </div>
                            <button @click="modelShow=true" v-if="item.title == '我的余额'" style="color: rgb(42, 80, 186);">充值</button>
                        </div>
                        <div class="data">
                            {{ item.data }}
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import pay from '../components/pay.vue'
export default {
    components: { pay },
    name: 'wellcome',
    //组件创建
    created() {
        this.getSys()
    },
    mounted() {
    },
    data() {
        return {
            modelShow:false,
            list: [
                { title: "我的余额", icon: require("../assets/yy.png"), data: "0", url: "" },
                { title: "今日认证", icon: require("../assets/jl.png"), data: "0", url: "" },
                { title: "今日上机", icon: require("../assets/jlu.png"), data: "0", url: "" }
            ],
            mes: "",
        }
    },
    methods: {
        modelShowChange(visible) {
      this.modelShow = visible
    },
        open() {
            this.$alert(this.mes, '系统公告', {
                confirmButtonText: '确定',
            })
        },
        getSys() {
            var that = this;
            this.$axios.get("/api2/business/getBoardData/" + this.$store.state.user.user.id, {
            })
                .then(function (response) {

                    console.log(response.data);
                    if (response.data.code == 200) {
                        that.list[2].data = response.data.data.takeCount
                        that.list[0].data = response.data.data.money
                        that.list[1].data = response.data.data.moneyCount
                        
                    } else {
                        that.$message.error(response.data.mes);
                    }
                })
        }
    }
}
</script>
<style  scoped>
.item:hover {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
}

.data {
    font-size: 30px;
    font-weight: 600;

    text-align: center;
}

.content {
    display: flex;
    float: left;
}

.item {

    margin-left: 30px;
    width: 200px;
    height: 100px;
    background-color: rgb(246, 248, 248);
}

.like {
    cursor: pointer;
    font-size: 25px;
    display: inline-block;
}

.icon {
    width: 20px;
    height: 20px;
}</style>